<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Froms"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Location">
                                        <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" changeOnSelect/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Status">
                                        <a-select v-model="inputStatus" showSearch placeholder="All Status" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in statusOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>

                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate per site
                            </base-checkbox>
                        
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage.js';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";
    import { getReportDescription } from '../../utilities.js';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                inputLocation: [],
                locationOptions: [],
                site_type: "ho",
                siteOptions: [],
                creditMemoReports: [],
                JsonData: [],
                reportDescription: '',
                inputStatus: 'All',
                isSeparateSite: 'false',
                statusOptions: [
                    { "id" : "all", "name": "All" },
                    { "id" : "open", "name": "Open"},
                    { "id" : "used", "name": "Used" },
                    { "id" : "partially used", "name": "Partially Used" },
                    { "id" : "expired", "name": "Expired" }
                ],
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
            this.reportDescription = await getReportDescription(this.currentProfile)

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            async onLocationChange(){
                var location = this.inputLocation[this.inputLocation.length - 1]
                if(!location){
                    this.handleClearInputLocation()
                }else {
                    this.siteOptions = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                    this.inputSite = this.siteOptions.map( s => s.id);
                }
                
            },
            async handleClearInputLocation() {
                    var userId = secureStorage.getItem("userId");
                    var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                    this.siteOptions = sites;
                    this.sort(this.siteOptions);
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
                    let siteId = secureStorage.getItem("defaultSiteId");
                    this.inputSite = [siteId]
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'credit_memo_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&status=' + this.inputStatus + '&is_separate_site=' + this.isSeparateSite, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }
                let reportLogo = document.getElementById('reportLogo');

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b3' });

                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    doc.setFontSize(14);
                    doc.setFontType("bold");

                    let design_y = 20
                    
                    doc.text(15,design_y,`Credit Memo Report`)
                    doc.setFontType("normal");
                    doc.setFontSize(10);

                    design_y = design_y + 5;
                    doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                    design_y = design_y + 5;
                    if(this.isSeparateSite == true){
                        doc.text(15, design_y, "Site: " + siteSpecific[x].report_details[0].site, "left");
                    } else {
                        let site_text = ''
                        if(this.inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = this.inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        doc.text(15, design_y, "Site/s: " + site_text, "left");
                    }

                    for (var x = 0; x < siteSpecific.length; x++){

                        if(x > 0){
                            //add new page
                            doc.addPage();
                            design_y = 10
                        }
                        
                        this.creditMemoReports = siteSpecific[x].report_details

                        let grouper = ''

                        let detailColStyles = {
                            0: {cellWidth: 20},
                            1: {cellWidth: 30},
                            2: {cellWidth: 30},
                            3: {cellWidth: 30},
                            4: {cellWidth: 70},
                            5: {cellWidth: 70},
                            6: {cellWidth: 70},
                            7: {cellWidth: 30},
                            8: {cellWidth: 30},
                            9: {cellWidth: 30},
                            10: {cellWidth: 30}
                            // 11: {cellWidth: 30}
                        } 
                        
                        let header = [
                            {content: 'CM Status', styles: {halign: 'center'}},
                            {content: 'CM Date', styles: {halign: 'center'}},
                            {content: 'Terminal', styles: {halign: 'center'}},
                            {content: 'Site', styles: {halign: 'center'}},
                            {content: 'Return Ref', styles: {halign: 'center'}},
                            {content: 'CM Ref', styles: {halign: 'center'}},
                            {content: 'Sales Ref', styles: {halign: 'center'}},
                            {content: 'Sales Date', styles: {halign: 'center'}},
                            {content: 'CM Amount', styles: {halign: 'center'}},
                            {content: 'CM Used', styles: {halign: 'center'}},
                            {content: 'CM Balance', styles: {halign: 'center'}}
                            // {content: 'Valid Until', styles: {halign: 'center'}}
                        ]

                        if(this.creditMemoReports.length > 0){
                            let reportData = []
                            let grouper = 'start'
                            
                            for(let i=0; i < this.creditMemoReports.length; i++){
                                let reportLine = this.creditMemoReports[i]
                                
                                if(this.isSeparateSite) {
                                    let grouper_name = reportLine.site
                                    if(grouper == 'start'){
                                        let detail_header = [{content: `Site: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.site_name){
                                            let detail_header = [{content: `Site: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.site_name
                                }  

                                //body
                                let detail = [
                                    {content: reportLine.cm_status, styles: {halign: 'left'}},
                                    {content: moment(reportLine.cm_date).format('MM/DD/YYYY hh:mm:ss A'), styles: {halign: 'left'}},
                                    {content: reportLine.terminal, styles: {halign: 'left'}},
                                    {content: reportLine.site, styles: {halign: 'left'}},
                                    {content: (reportLine.return_ref == null) ? '' : reportLine.return_ref, styles: {halign: 'left'}},
                                    {content: (reportLine.cm_ref == null) ? '' : reportLine.cm_ref, styles: {halign: 'left'}},
                                    {content: (reportLine.sales_ref == null) ? '' : reportLine.sales_ref, styles: {halign: 'left'}},
                                    {content: (reportLine.sales_date == null) ? '-' : moment(reportLine.sales_date).format('MM/DD/YYYY hh:mm:ss A'), styles: {halign: 'left'}},
                                    {content: this.convertToCurrency(Number(reportLine.cm_amount)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.cm_used)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.cm_balance)), styles: {halign: 'right'}}
                                    // {content: moment(reportLine.valid_until).format('MM/DD/YYYY hh:mm:ss A'), styles: {halign: 'left'}}
                                ]
                                
                                reportData.push(detail)
                                
                                if(i == this.creditMemoReports.length-1){

                                    //create table
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [header],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    for(let i = 0; i < pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Credit Memo Report", 485, 342, i, pageCount, "right")
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'credit_memo_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&status=' + this.inputStatus + '&is_separate_site=' + this.isSeparateSite, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let headers = [];
                    let site_specific = [];
                    for(var x=0; x < siteSpecific.length; x++){
                        this.creditMemoReports = siteSpecific[x].report_details

                        let grouper = ''

                        headers = ['CM Status','CM Date','Terminal','Site','Return Ref','CM Ref','Sales Ref','Sales Date','CM Amount','CM Used','CM Balance']
                        let reportData = []
                        if(this.creditMemoReports.length > 0){
                            let grouper = 'start'

                            for(let i=0; i < this.creditMemoReports.length; i++){
                                let reportLine = this.creditMemoReports[i]
                                
                                //body
                                let detail = [
                                              reportLine.cm_status,
                                              moment(reportLine.cm_date).format('MM/DD/YYYY hh:mm:ss A'),
                                              reportLine.terminal,
                                              reportLine.site,
                                              (reportLine.return_ref == null) ? '' : reportLine.return_ref,
                                              (reportLine.cm_ref == null) ? '' : reportLine.cm_ref,
                                              (reportLine.sales_ref == null) ? '' : reportLine.sales_ref,
                                              (reportLine.sales_date == null) ? '-' : moment(reportLine.sales_date).format('MM/DD/YYYY hh:mm:ss A'),
                                              this.convertToCurrency(Number(reportLine.cm_amount)),
                                              this.convertToCurrency(Number(reportLine.cm_used)),
                                              this.convertToCurrency(Number(reportLine.cm_balance))
                                              ]
                                reportData.push(detail)
                            }
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
            getBase64Image(url) {
                    const img = new Image();
                    img.setAttribute('crossOrigin', 'anonymous');
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        const dataURL = canvas.toDataURL("image/png");
                    }
                    return img.src = url
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Credit Memo Report", {
                    pageSetup:{paperSize: 9}
                });

                var from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                var to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                const data_starts_at_row = 8

                let reportLogo = document.getElementById('reportLogo');
            
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)

                const imageId2 = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });

                sheet.addImage(imageId2, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 61, height: 61 }
                });

                sheet.getRow(4).values = ["Credit Memo Report"]
                sheet.getRow(5).values = [`For the Period of ${from_date} to ${to_date}`]
                
                let site_text = (this.inputSite.length == 0) ? 'All Sites': '';
                    let sites = this.inputSite
                    if(sites.length > 0) {
                        for (var s = 0; s < sites.length; s++) {
                            if(s == 0){
                                site_text += this.siteOptions.find(x => x.id === sites[s]).name
                            } else {
                                site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                            }
                        }
                    }
                sheet.getRow(6).values = ['Sites: ' + site_text]

                //custom header
                sheet.getRow(data_starts_at_row).values = ["CM Status", "CM Date", "Terminal", "Site",
                    "Return Ref", "CM Ref", "Sales Ref", "Sales Date", "CM Amount", "CM Used", "CM Balance"];
                    
                sheet.columns = [
                    { key: "cm_status" , width: 15 },
                    { key: "cm_date" , width: 20 },
                    { key: "terminal" , width: 20 },
                    { key: "site" , width: 20 },
                    { key: "return_ref" , width: 30 },
                    { key: "cm_ref" , width: 30 },
                    { key: "sales_ref", width: 30 },
                    { key: "sales_date" , width: 20 },
                    { key: "cm_amount", width: 15 },
                    { key: "cm_used", width: 15 },
                    { key: "cm_balance" , width: 15 },
                ];
                
                var report_details = this.JsonData
                var rowDatas = []
                var horizontal_range = 0
                for(let i = 0; i < report_details.length; i++){
                    const report_detail = report_details[i]
                    if(report_detail){
                        const rowData = {cm_status: report_detail["CM Status"], cm_date: report_detail["CM Date"], terminal: report_detail["Terminal"], 
                        site: report_detail["Site"], return_ref: report_detail["Return Ref"], cm_ref: report_detail["CM Ref"], 
                        sales_ref: report_detail["Sales Ref"] ,sales_date: report_detail["Sales Date"], cm_amount: report_detail["CM Amount"], cm_used: report_detail["CM Used"], cm_balance: report_detail["CM Balance"]}
                        rowDatas.push(rowData)
                    }
                }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(4).font = { bold: true, size: 16 };
                sheet.getRow(4).height = 20;
                // sheet.getRow(7).font = { bold: true };
                sheet.getRow(data_starts_at_row).font = { bold: true };

                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `CreditMemoReport.xlsx`);
                });
                this.JsonData = []
            },
        }
    };
</script>

<style></style>
